import { useEffect } from 'react';
import IframeWrapper from '../backoffice/iframe-wrapper';

const FinancingOrders = () => {
	useEffect(() => {
		const handleMessage = (event: MessageEvent) => {
			const origins = [
				'https://studio-dev.nuqlea.com',
				'https://studio.nuqlea.com',
				'https://backoffice-dev.nuqlea.com',
				'https://backoffice.nuqlea.com',
				'http://localhost:3000',
				'http://localhost:3001',
				'http://localhost:5001',
			];
			if (!origins.includes(event.origin)) {
				return;
			}

			const { type } = event.data;
			if (type === 'cta') {
				const hubspot = (typeof window !== 'undefined' ? window : (globalThis as any)).HubSpotConversations;
				hubspot?.widget.open();
			}
		};

		window.addEventListener('message', handleMessage);

		return () => {
			window.removeEventListener('message', handleMessage);
		};
	}, []);

	return <IframeWrapper path='/shared/nuqlea-financing/buyer' />;
};

export default FinancingOrders;
